module.exports = __webpack_public_path__ + "gfx/VCP-DECT-R8-03.png";